import $ from 'jquery';
import '../vendor/slick';
import {register} from '@shopify/theme-sections';

register('product-grid-slider', {
  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.$slideshow = $('[data-product-grid-slider]', this.$container);

    this.$slideshow.slick({
      arrows: false,
      dots: true,
      autoplay: false,
      cssEase: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  },

  onBlockSelect(event) {
    const $target = $(event.target);
    const $slide = $target.closest('[data-slick-index]');
    const index = $slide.attr('data-slick-index');

    this.$slideshow.slick('slickPause');
    this.$slideshow.slick('slickGoTo', index);
  },

  onDeselect() {
    this.$slideshow.slick('slickPlay');
  },

  onUnload() {
    this.$container.off(this.namespace);
    this.$slideshow.slick('unslick');
  },
});
